import React from 'react'
import ReactDOM from 'react-dom/client';
import './global-styles/imports.scss'
import AppRouter from './AppRouter';
import {BrowserRouter} from 'react-router-dom'
import {UserProvider} from './context/UserContext'
import {HelmetProvider } from 'react-helmet-async';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <UserProvider>
                <HelmetProvider>
                    <AppRouter />
                </HelmetProvider>
            </UserProvider>
        </BrowserRouter>
    </React.StrictMode>
)
